import gql from 'graphql-tag';
import graphqlClient from '@shared/graphql/client';

export class CoachService {
  static async update(id, data, manage) {
    const response = await graphqlClient.mutate({
      mutation: gql`
        mutation COACH_UPDATE(
          $id: String!
          $data: CoachInput!
          $manage: ManageInput!
        ) {
          coachUpdate(id: $id, data: $data, manage: $manage) {
            id
          }
        }
      `,

      variables: {
        id,
        data,
        manage,
      },
    });

    return response.data.coachUpdate;
  }

  static async destroyAll(ids, manage) {
    const response = await graphqlClient.mutate({
      mutation: gql`
        mutation COACH_DESTROY($ids: [String!]! $manage: ManageInput!) {
          coachDestroy(ids: $ids, manage: $manage)
        }
      `,

      variables: {
        ids,
        manage
      },
    });

    return response.data.coachDestroy;
  }

  static async create(data, manage) {
    const response = await graphqlClient.mutate({
      mutation: gql`
        mutation COACH_CREATE($data: CoachInput! $manage: ManageInput!) {
          coachCreate(data: $data, manage: $manage) {
            id
          }
        }
      `,

      variables: {
        data,
        manage,
      },
    });

    return response.data.coachCreate;
  }

  static async import(values, importHash, manage) {
    const response = await graphqlClient.mutate({
      mutation: gql`
        mutation COACH_IMPORT(
          $data: CoachInput!
          $importHash: String!
          $manage: ManageInput!
        ) {
          coachImport(data: $data, importHash: $importHash, manage: $manage)
        }
      `,

      variables: {
        data: values,
        importHash,
        manage,
      },
    });

    return response.data.coachImport;
  }

  static async find(id, manage) {
    const response = await graphqlClient.query({
      query: gql`
        query COACH_FIND($id: String! $manage: ManageInput!) {
          coachFind(id: $id, manage: $manage) {
            id
            teams {
              id
              name
            }
            firstName
            lastName
            birthdate {
              day
              month
              year
            }
            email
            phoneNumber {
              prefix
              number
            }
            gender
            country
            type
            lastLogin
            createdAt
            updatedAt
          }
        }
      `,

      variables: {
        id,
        manage,
      },
    });

    return response.data.coachFind;
  }

  static async list(filter, orderBy, limit, offset, manage) {

    if ( !manage.subpropertyId ) return { rows: [], count: 0};

    const response = await graphqlClient.query({
      query: gql`
        query COACH_LIST(
          $filter: CoachFilterInput
          $orderBy: CoachOrderByEnum
          $limit: Int
          $offset: Int
          $manage: ManageInput!
        ) {
          coachList(
            filter: $filter
            orderBy: $orderBy
            limit: $limit
            offset: $offset
            manage: $manage
          ) {
            count
            rows {
              id
              teams {
                id
                name
              }
              firstName
              lastName
              birthdate {
                day
                month
                year
              }
              email
              phoneNumber {
                prefix
                number
              }
              gender
              country
              type
              lastLogin
              updatedAt
              createdAt
              lastLogin
            }
          }
        }
      `,

      variables: {
        filter,
        orderBy,
        limit,
        offset,
        manage,
      },
    });
    
    return response.data.coachList;
  }

  static async listAutocomplete(query, limit, manage) {
    const response = await graphqlClient.query({
      query: gql`
        query COACH_AUTOCOMPLETE(
          $query: String
          $limit: Int
          $manage: ManageInput!
        ) {
          coachAutocomplete(query: $query, limit: $limit, manage: $manage) {
            id
            label
          }
        }
      `,

      variables: {
        query,
        limit,
        manage,
      },
    });

    return response.data.coachAutocomplete;
  }
}
